import { SearchInput } from 'react-admin'

const SchoolTagListFilters = [
    <SearchInput variant="outlined" placeholder="Search name" source="tag" alwaysOn />
]

export default SchoolTagListFilters
